export default __webpack_public_path__ + "static/media/sticker_pc.985161b3.svg";